export default "__VITE_ASSET__D6yo$bp9__"